import logoDark from "src/assets/logo_dark.png";
import logoLight from "src/assets/logo_light.png";
import useIsLightMode from "src/hooks/useIsLightMode";

const Icon = ({
  icon,
}: {
  icon?: {
    src: string;
    alt: string;
    width?: number;
    height?: number;
  };
}) => {
  const isLightMode = useIsLightMode();
  const Logo = isLightMode ? logoLight : logoDark;
  if (icon) {
    return (
      <img
        alt={icon.alt}
        title={icon.alt}
        src={icon.src}
        width={icon.width ?? 64}
        height={icon.height ?? 64}
        style={{ margin: "auto", marginBottom: "1rem" }}
        loading="eager"
      />
    );
  }

  return (
    <a href="/" style={{ margin: "auto", marginBottom: "1rem" }}>
      <img
        alt={"Pre Reg Shortcuts Logo"}
        title={"Pre Reg Shortcuts Logo"}
        src={Logo}
        width={123}
        height={64}
        loading="eager"
      />
    </a>
  );
};

export { Icon };
